import React from 'react';
import {WaveformLoaderWebsites} from '../../../components/inputs/WaveformLoaderWebsites';
import VendorSearch from '../../../components/inputs/VendorSearch';
import AgentSearch from '../../../components/inputs/AgentSearch';
import {MdOpenInNew} from 'react-icons/md';
import {LuHistory} from 'react-icons/lu';
import QuickHistory from '../../website/history/QuickHistory';

const DefaultInputs = ({form, handleChange, initialLoading, darkMode, loaderWidth, website, openInNewTab, handleStatusChange, handleProductChange, products, isExpanded,
                         hasHistory, toggleHistory, isHistoryOpen, quickHistoryRef, handleMouseEnter, handleMouseLeave, placeholder, vendorLinkDisabled, selectedLocalVendor, setSelectedLocalVendor, setForm,
                         startLoading, stopLoading, vendorReciprocalAllowed, handleVendorInputClick,}) => {
  return (
    <div className="space-y-4">
      <div className={`grid ${isExpanded ? 'grid-cols-2' : 'grid-cols-1 1150:grid-cols-12'} gap-4`}>
        <div className={`col-span-1 1150:col-span-5 ${isExpanded ? 'w-[480px]' : ''}`}>
          <label className="block">
            <span className="label">Vendor</span>
            {initialLoading ? (
              <WaveformLoaderWebsites
                isLoading={true}
                darkMode={darkMode}
                width="350px"
                height="2.375rem"
                marginTop="0.275rem"
              />
            ) : website ? (
              <button
                className="mt-1 block w-full text-left rounded-md border border-gray-300 bg-gray-100 px-2 py-1.5 font-semibold text-gray-600 underline dark:border-stone-700 dark:bg-stone-700 dark:text-gray-300"
                onClick={handleVendorInputClick}
                title={form.vendor}
              >
                {form.vendor?.length > 30 ? `${form.vendor.slice(0, 30)}…` : form.vendor}
              </button>
            ) : (
              <VendorSearch
                vendor={form.vendor}
                excludeInactive={true}
                selectedVendor={selectedLocalVendor}
                onVendorSelect={(vendor) => {
                  setSelectedLocalVendor(vendor);
                  setForm((prevForm) => ({
                    ...prevForm,
                    vendor: vendor.licensee,
                    vendorId: vendor.rowKey,
                  }));
                }}
                vendorLinkDisabled={vendorLinkDisabled}
              />
            )}
          </label>
        </div>
        <div className={`relative col-span-1 1150:col-span-7 ${isExpanded ? 'w-[480px]' : ''}`}>
          <label className="block relative">
            <span className="label">Domain Name</span>
            {initialLoading ? (
              <WaveformLoaderWebsites
                isLoading={true}
                darkMode={darkMode}
                width={loaderWidth}
                height="2.375rem"
                marginTop="0.275rem"
              />
            ) : (
              <input
                className="website-input w-full pr-10"
                type="text"
                name="domainName"
                maxLength="100"
                placeholder="Domain Name"
                value={form.domainName}
                onChange={handleChange}
                onFocus={() => startLoading('domainName')}
                onBlur={() => stopLoading('domainName')}
                autoComplete="off"
              />
            )}
            {website && (
              <MdOpenInNew
                className="h-4.5 w-4.5 absolute top-11 mt-0.5 right-3 transform -translate-y-1/2 cursor-pointer dark:text-gray-300 md:hidden 1150:block"
                onClick={() => openInNewTab(form.domainName)}
              />
            )}
            {website && (
              <MdOpenInNew
                className="h-4.5 w-4.5 absolute top-11 mt-0.5 right-3 transform -translate-y-1/2 cursor-pointer dark:text-gray-300 md:block 1150:hidden"
                onClick={() => openInNewTab(form.domainName)}
              />
            )}
          </label>
        </div>
      </div>

      <div className={`grid ${isExpanded ? 'w-[480px] grid-cols-2' : 'grid-cols-1 1150:grid-cols-12'} gap-4`}>
        <div className={`col-span-1 1150:col-span-3 ${isExpanded ? 'pt-10 w-full' : ''}`}>
          <label className="block">
            <div className="flex items-center text-blue-600 hover:text-blue-800 dark:text-indigo-500 dark:hover:text-indigo-700">
              <span className="label mr-2">Status</span>
              {hasHistory && (
                <button
                  type="button"
                  onClick={toggleHistory}
                  className="z-50 flex items-center"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <LuHistory className="mt-0.5 h-3 w-3" title="History"/>
                  <span className="ml-1 text-xs font-semibold">History</span>
                </button>
              )}
            </div>
            {initialLoading ? (
              <WaveformLoaderWebsites
                isLoading={true}
                darkMode={darkMode}
                width={loaderWidth}
                height="2.375rem"
                marginTop="0.275rem"
              />
            ) : (
              <select
                className="mt-1 block w-full rounded-md border border-gray-300 bg-gray-100 px-2 py-2 dark:border-stone-700 dark:bg-stone-700 dark:text-gray-300"
                name="status"
                value={form.status}
                onChange={handleStatusChange}
              >
                <option disabled value="">Select</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
                <option value="Pending Activation">Pending (Activation)</option>
                <option value="Pending Termination">Pending (Termination)</option>
                <option value="Pending Change">Pending (Change)</option>
              </select>
            )}
          </label>
        </div>
        {hasHistory && isHistoryOpen && (
          <div className="fixed z-50 flex dark:bg-opacity-95 mt-3">
            <div
              ref={quickHistoryRef}
              className="relative w-full overflow-auto rounded-lg border border-gray-300 bg-white pb-3 shadow-lg dark:border-gray-600 dark:bg-stone-800"
            >
              <div className="px-4">
                <QuickHistory />
              </div>
            </div>
          </div>
        )}
        <div className={`col-span-1 1150:col-span-3 ${isExpanded ? 'pt-10 w-full' : ''}`}>
          <label className="block">
            <span className="label">DBA</span>
            {initialLoading ? (
              <WaveformLoaderWebsites
                isLoading={true}
                darkMode={darkMode}
                width={loaderWidth}
                height="2.375rem"
                marginTop="0.275rem"
              />
            ) : (
              <input
                className="website-input w-full"
                type="text"
                name="dba"
                maxLength="512"
                placeholder="Doing Business As"
                value={form.dba}
                onChange={handleChange}
                autoComplete="off"
              />
            )}
          </label>
        </div>
        <div className={`col-span-1 1150:col-span-6 ${isExpanded ? 'pt-10' : ''}`}>
          <label className="block">
            <span className="label">Agent Search</span>
            {initialLoading ? (
              <WaveformLoaderWebsites
                isLoading={initialLoading}
                darkMode={darkMode}
                width="100%"
                height="2.375rem"
                marginTop="0.275rem"
              />
            ) : (
              <div className="relative">
                <AgentSearch
                  placeholder={placeholder}
                  reciprocalAllowed={website?.reciprocalAllowed ?? vendorReciprocalAllowed}
                  onAgentSelect={(agent) => {
                    setForm((prevForm) => ({
                      ...prevForm,
                      agentSearch: `${agent.firstName} ${agent.lastName}`,
                      firstName: agent.firstName,
                      lastName: agent.lastName,
                      mlsId: agent.mlsId,
                      memberNumber: agent.memberNumber,
                      office: agent.office,
                      mlsStatus: agent.broker?.status ? 'Active' : 'Inactive',
                      broker: agent.broker
                        ? {
                          ...prevForm.broker,
                          firstName: agent.broker.firstName,
                          lastName: agent.broker.lastName,
                          mlsId: agent.broker.mlsId,
                          memberNumber: agent.broker.memberNumber,
                          office: agent.broker.office,
                          licenseNumber: agent.broker.licenseNumber,
                          status: agent.broker.status,
                        }
                        : prevForm.broker,
                    }));
                  }}
                />
              </div>
            )}
          </label>
        </div>
      </div>

      <div className={`grid grid-cols-1 1150:grid-cols-12 gap-4 ${isExpanded ? 'pt-10' : ''}`}>
        <div className="col-span-1 1150:col-span-3">
          <label className="block">
            <span className="label">Start Date</span>
            {initialLoading ? (
              <WaveformLoaderWebsites
                isLoading={true}
                darkMode={darkMode}
                width={loaderWidth}
                height="2.375rem"
                marginTop="0.275rem"
              />
            ) : (
              <input
                className="website-input w-full"
                type="date"
                name="startDate"
                value={form.startDate}
                onChange={handleChange}
              />
            )}
          </label>
        </div>
        <div className="col-span-1 1150:col-span-3">
          <label className="block">
            <span className="label">Term Date</span>
            {initialLoading ? (
              <WaveformLoaderWebsites
                isLoading={true}
                darkMode={darkMode}
                width={loaderWidth}
                height="2.375rem"
                marginTop="0.275rem"
              />
            ) : (
              <input
                className="website-input w-full"
                type="date"
                name="termDate"
                value={form.termDate}
                onChange={handleChange}
              />
            )}
          </label>
        </div>
        <div className="col-span-1 1150:col-span-3">
          <label className="block">
            <span className="label">Member Number</span>
            {initialLoading ? (
              <WaveformLoaderWebsites
                isLoading={true}
                darkMode={darkMode}
                width={loaderWidth}
                height="2.375rem"
                marginTop="0.275rem"
              />
            ) : (
              <input
                readOnly
                className="website-input w-full"
                type="text"
                name="memberNumber"
                placeholder="Member Number"
                value={form.memberNumber}
              />
            )}
          </label>
        </div>
        <div className="col-span-1 1150:col-span-3">
          <label className="block">
            <span className="label">Product</span>
            {initialLoading ? (
              <WaveformLoaderWebsites
                isLoading={true}
                darkMode={darkMode}
                width={loaderWidth}
                height="2.375rem"
                marginTop="0.275rem"
              />
            ) : (
              <select
                className="mt-1 block w-full rounded-md border border-gray-300 bg-gray-100 px-2 py-2 dark:border-stone-700 dark:bg-stone-700 dark:text-gray-300"
                name="product"
                value={form.products?.[0] || ''}
                onChange={handleProductChange}
              >
                <option disabled value="">Select</option>
                {products.map((product) => (
                  <option
                    key={product.id}
                    value={product.id}
                    title={`${product.name} (${product.shortName})`}
                  >
                    {product.name.length > 20
                      ? `${product.name.substring(0, 20)}...`
                      : product.name}
                  </option>
                ))}
              </select>
            )}
          </label>
        </div>
      </div>

      <div className={`grid ${isExpanded ? 'grid-cols-2 pt-10' : 'grid-cols-1 1150:grid-cols-12'} gap-4`}>
        <div className={`col-span-1 1150:col-span-4 ${isExpanded ? 'w-1/2' : ''}`}>
          <label className="block">
            <span className="label">MLS ID</span>
            {initialLoading ? (
              <WaveformLoaderWebsites
                isLoading={true}
                darkMode={darkMode}
                width={loaderWidth}
                height="2.375rem"
                marginTop="0.275rem"
              />
            ) : (
              <input
                readOnly
                className="website-input w-full"
                type="text"
                name="mlsId"
                placeholder="MLS ID"
                value={form.mlsId}
              />
            )}
          </label>
        </div>
        <div className={`col-span-1 1150:col-span-4 ${isExpanded ? 'w-1/2' : ''}`}>
          <label className="block">
            <span className="label">Full Name</span>
            {initialLoading ? (
              <WaveformLoaderWebsites
                isLoading={true}
                darkMode={darkMode}
                width={loaderWidth}
                height="2.375rem"
                marginTop="0.275rem"
              />
            ) : (
              <input
                readOnly
                className="website-input w-full"
                type="text"
                name="fullName"
                placeholder="Full Name"
                value={form.firstName + ' ' + form.lastName}
              />
            )}
          </label>
        </div>
        <div className={`col-span-1 1150:col-span-4 ${isExpanded ? 'w-1/2' : ''}`}>
          <label className="block">
            <span className="label">Office Name</span>
            {initialLoading ? (
              <WaveformLoaderWebsites
                isLoading={true}
                darkMode={darkMode}
                width={loaderWidth}
                height="2.375rem"
                marginTop="0.275rem"
              />
            ) : (
              <input
                readOnly
                className="website-input w-full"
                type="text"
                name="officeName"
                placeholder="Office Name"
                value={form.office}
              />
            )}
          </label>
        </div>
      </div>

      <div className={`grid ${isExpanded ? 'grid-cols-2 pt-10' : 'grid-cols-1 1150:grid-cols-12'} gap-4`}>
        <div className={`col-span-1 1150:col-span-4 ${isExpanded ? 'w-1/2' : ''}`}>
          <label className="block">
            <span className="label">MLS Status</span>
            {form.mlsStatus !== undefined ? (
              <div className="relative">
                {initialLoading ? (
                  <WaveformLoaderWebsites
                    isLoading={initialLoading}
                    darkMode={darkMode}
                    width="100%"
                    height="2.4rem"
                  />
                ) : (
                  <input
                    readOnly
                    className="website-input w-full"
                    type="text"
                    name="activeStatus"
                    value={form.mlsStatus || 'None'}
                  />
                )}
              </div>
            ) : (
              <input
                readOnly
                className="website-input w-full"
                type="text"
                name="activeStatus"
                placeholder="Agent Status"
              />
            )}
          </label>
        </div>
        <div className={`col-span-1 1150:col-span-4 ${isExpanded ? 'w-1/2' : ''}`}>
          <label className="block">
            <span className="label">DRE</span>
            {initialLoading ? (
              <WaveformLoaderWebsites
                isLoading={true}
                darkMode={darkMode}
                width={loaderWidth}
                height="2.375rem"
                marginTop="0.275rem"
              />
            ) : (
              <input
                readOnly
                className="website-input w-full"
                type="text"
                name="licenseNumber"
                placeholder="DRE"
                value={form.licenseNumber || ''}
              />
            )}
          </label>
        </div>
        <div className={`col-span-1 1150:col-span-4 ${isExpanded ? 'w-1/2' : ''}`}>
          <label className="block">
            <span className="label">Office Broker</span>
            {initialLoading ? (
              <WaveformLoaderWebsites
                isLoading={true}
                darkMode={darkMode}
                width={loaderWidth}
                height="2.375rem"
                marginTop="0.275rem"
              />
            ) : (
              <input
                readOnly
                className="website-input w-full"
                type="text"
                name="broker"
                placeholder="Office Broker"
                value={`${form.broker?.firstName || ''} ${form.broker?.lastName || ''}`}
              />
            )}
          </label>
        </div>
      </div>
    </div>
  );
};

export default DefaultInputs;